import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatDialog } from '@angular/material/dialog';
import { PlayVideoDialogComponent } from '../play-video-dialog/play-video-dialog.component';


@Component({
  selector: 's18-how-to',
  templateUrl: './how-to.component.html',
  styleUrls: ['./how-to.component.scss']
})
export class HowToComponent implements OnInit {

  selectedTabIndex: number = 0;

  constructor(
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
  }

  selectionChange(event:MatTabChangeEvent){
    setTimeout( () => {
      this.selectedTabIndex = event.index;
    }, 500)
  }

  playVideo(fileName){
    var dialogRef = this.dialog.open(PlayVideoDialogComponent, { 
      panelClass: 'move-up',
      data: {
        videoFileName: fileName
      }
    });

    dialogRef.afterClosed().subscribe( () => {
      //this.scrollToService.scrollTo({target: '#product-calculator'});
    });
  }
}
